import { trackSiteGlueEvent } from "~/lib/siteglue/cta-config";
import { getAttributionAnalyticsPayload } from "~/lib/siteglue/marketing-attribution";

const AI_REFERRED_SOURCES = ["chatgpt.com", "grok", "claude"];

export function isAiReferredTraffic(): boolean {
  if (typeof window === "undefined") return false;
  const payload = getAttributionAnalyticsPayload();
  const source = (payload.utm_source ?? "").toLowerCase();
  const referrer = document.referrer.toLowerCase();
  return AI_REFERRED_SOURCES.some(
    (token) => source.includes(token) || referrer.includes(token),
  );
}

export function trackLandingEvent(
  eventName: string,
  extra?: Record<string, string | number | boolean | undefined>,
): void {
  trackSiteGlueEvent(eventName, {
    ai_referred: isAiReferredTraffic(),
    ...extra,
  });
}
